module.exports = __webpack_public_path__ + "static/media/white-device.aaf09f56.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/white-device.png
// module id = 378
// module chunks = 0